import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { expose, emit }) {

const props = __props;





const chars = ref<string[]>([]);

const items = ref<HTMLDivElement[]>([]);

const formElement = useFormElement({
  emit,
  props,
});

const { readonly, inputClass, inputErrorClass, fieldErrorsShown } = useBaseFieldValues(formElement);

const { modelStateRef, emitFormEvent, field, model, setValue } = formElement;

function onOtpKeyDown(event: KeyboardEvent, index: number) {
  if (event.key === 'Backspace' && !(event.target as any).value) {
    const next = items.value[constrainIndex(index - 1)].firstElementChild as HTMLInputElement;
    next.focus();
  } else if (event.key === 'Enter') {
    emitFormEvent({
      event: 'form-field-submit',
    });
  }
}

function onOtpInput(event: InputEvent, index: number) {
  const strings = (event.target as any).value.split('');
  const nextIndex = constrainIndex(strings.length + index);
  const next = items.value[nextIndex].firstElementChild as HTMLInputElement;
  if (strings.length) {
    strings.forEach((char: string, charIndex: number) => {
      if (charIndex + index < otpParts.value) {
        const number = parseInt(char, 10);
        chars.value[charIndex + index] = Number.isNaN(number) ? '' : number.toString();
        chars.value = [...chars.value];
        if (!Number.isNaN(number)) {
          next.focus();
        }
      }
    });
  } else {
    chars.value[index] = '';
    chars.value = [...chars.value];
  }
}

function constrainIndex(index: number) {
  return Math.max(Math.min(index, otpParts.value - 1), 0);
}

const otpParts = modelStateRef('length', 6);

function onFocus(event: FocusEvent) {
  const target: HTMLInputElement = event.target as HTMLInputElement;
  if (target) {
    target.setSelectionRange(0, target.value.length);
  }
}

function onBlur() {
  setTimeout(() => {
    let internal = false;
    items.value.forEach((item: any) => {
      if (document.activeElement && document.activeElement === item.firstElementChild) {
        internal = true;
      }
    });
    if (!internal) {
      field.value.$touch();
    }
  });
}

function triggerFieldAction(path: string, action: any) {
  if (model.value.$path === path && action === 'focus') {
    const input = items.value[0].firstElementChild as HTMLInputElement;
    input?.focus();
  }
}

watch(chars, () => setValue(chars.value));

watch(
  () => field.value.$model,
  () => {
    chars.value = Array.isArray(field.value.$model) ? field.value.$model : [];
  }
);

expose({
  triggerFieldAction,
});

return { __sfc: true,props, emit, chars, items, formElement, readonly, inputClass, inputErrorClass, fieldErrorsShown, modelStateRef, emitFormEvent, field, model, setValue, onOtpKeyDown, onOtpInput, constrainIndex, otpParts, onFocus, onBlur, triggerFieldAction }
}

})